var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "definition-list"
  }, [_vm._l((_vm.items), function(item) {
    return [_c('dt', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(item.value))])]
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21c2ac68","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/DefinitionList.vue
// module id = 1901
// module chunks = 0